
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M1.956 2.667h12.088c.198 0 .384.048.552.129L8.911 8.452a1.29 1.29 0 01-1.823 0L1.403 2.796c.168-.08.354-.13.553-.13zm-1.16.736c-.08.168-.13.354-.13.553v7.734c0 .198.05.384.13.552l4.448-4.42L.796 3.404zm9.96 4.42l4.448-4.42c.08.168.13.354.13.553v7.734c0 .198-.05.384-.13.552l-4.448-4.42zM9.52 9.06l.63-.63 4.447 4.42c-.168.08-.354.13-.552.13H1.956c-.199 0-.385-.05-.553-.13l4.448-4.42.63.63a2.15 2.15 0 003.038 0z","fill":"green"}})])
          )
        }
      }
    